import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        main: {
            w: '100%',
            backgroundColor: 'background.default',
        },
        container: {
            w: '100%',
            maxW: {xl: remCalc(1400), base: '100%'},
            mx: 'auto',
            mb: {base: remCalc(16), md: remCalc(24), lg: remCalc(40)},
            px: {base: remCalc(16), md: remCalc(24), xl: 0},
            flexDirection: 'column',
            textAlign: 'center',
            justifyContent: 'center',
        },
        chevronIcon: {
            w: {
                base: 'iconsSize.medium',
                md: 'iconsSize.small',
                lg: 'iconsSize.medium',
                xl: 'iconsSize.xlarge',
            },
            h: {
                base: 'iconsSize.medium',
                md: 'iconsSize.small',
                lg: 'iconsSize.medium',
                xl: 'iconsSize.xlarge',
            },
            position: 'absolute',
            backgroundColor: 'background.default',
            borderWidth: remCalc(1),
            borderColor: 'text.default',
            borderRadius: '50%',
            top: {base: remCalc(166), md: remCalc(84), lg: remCalc(113), xl: remCalc(166)},
            transform: 'translateY(-50%)',
            cursor: 'pointer',
            zIndex: '10',
        },
        heading: {
            pt: {base: remCalc(16), md: remCalc(40)},
            pb: {base: remCalc(16), md: remCalc(24)},
            w: '100%',
            textStyle: 'head-large',
            fontWeight: 'medium',
        },
        bodycopy: {
            w: '100%',
            textStyle: 'body-large',
            fontWeight: 'normal',
            pb: {base: remCalc(16), md: remCalc(40)},
        },
        emptyTiles: {
            minH: {base: remCalc(332), md: remCalc(168), lg: remCalc(226), xl: remCalc(332)},
        },
        noswipertiles: {
            gap: {base: remCalc(16), lg: remCalc(24)},
            pb: remCalc(24),
        },
        flexbasis: {
            flexBasis: '25%',
            minH: '100%',
        },
        tile: {
            main: {
                gap: remCalc(24),
                flexDirection: 'column',
                justifyContent: 'flex-start',
                minH: '100%',
            },
            imagecontainer: {
                textAlign: 'center',
            },
            image: {
                w: '100%',
                m: 'auto',
                maxW: {base: remCalc(332), md: remCalc(168), lg: remCalc(226), xl: remCalc(332)},
                minW: {base: remCalc(332), md: 'unset'},
            },
            title: {
                textStyle: 'head-small',
                fontWeight: 'medium',
            },
            bodycopy: {
                textStyle: 'body-medium',
                fontWeight: 'normal',
            },
            features: {
                listStyleType: 'none',
            },
            feature: {
                py: remCalc(20),
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
            },
            cta: {
                w: '100%',
                alignSelf: 'center',
                whiteSpace: 'unset',
                mt: 'auto',
            },
        },
        ctaContainer: {
            w: '100%',
            gap: {base: remCalc(16), md: remCalc(24)},
            flexDirection: {base: 'column', md: 'row'},
            justifyContent: {base: 'flex-start', md: 'center'},
            alignItems: {base: 'center', md: 'flex-start'},
        },
        ctas: {
            w: {base: remCalc(228), md: remCalc(168), lg: remCalc(226), xl: remCalc(332)},
        },
    },
    variants: {
        recipesCarousel: {
            container: {
                maxW: '100%',
            },
            image: {
                w: '100%',
                m: 'auto',
                maxW: 'unset',
                minW: 'unset',
            },
            tile: {
                gap: {
                    base: 'xsmall.base',
                    md: 'medium.base',
                },
                minH: 'unset',
                image: {
                    maxWidth: 'unset',
                    minWidth: 'unset',
                },
            },
        },
        black: {
            main: {
                backgroundColor: 'background.dark',
                color: 'text.inverse',
            },
            chevronIcon: {
                borderColor: 'text.inverse',
            },
        },
    },
}
